import { useEffect } from "react";
import { createChat } from "@n8n/chat";
import "@n8n/chat/style.css";
import "../styles/n8n-chat-theme.css";

// Accessibility helpers for n8n widget (DOM-level patching)
function enhanceAccessibility() {
  let chatOpen = false; // 👈 ננהל state בעצמנו

  const interval = setInterval(() => {
    const toggle = document.querySelector(
      ".chat-window-toggle"
    ) as HTMLElement | null;

    const chatRoot = document.querySelector(".n8n-chat") as HTMLElement | null;

    /* ---------------- TOGGLE PATCH ---------------- */

    if (toggle && !toggle.hasAttribute("data-a11y-patched")) {
      toggle.setAttribute("role", "button");
      toggle.setAttribute("tabindex", "0");
      toggle.setAttribute("aria-label", "פתיחת צ׳אט עזרה משפטית");

      // Keyboard activation
      toggle.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle.click();
        }
      });

      // Track open/close + focus input
      toggle.addEventListener("click", () => {
        chatOpen = !chatOpen;

        if (chatOpen) {
          setTimeout(() => {
            const input = document.querySelector(
              ".n8n-chat input, .n8n-chat textarea"
            ) as HTMLElement | null;

            input?.focus();
          }, 300);
        }
      });

      toggle.setAttribute("data-a11y-patched", "true");
    }

    /* ---------------- CHAT ROOT PATCH ---------------- */

    if (chatRoot && !chatRoot.hasAttribute("data-a11y-patched")) {
      chatRoot.setAttribute("role", "dialog");
      chatRoot.setAttribute("aria-label", "צ׳אט עזרה משפטית");
      chatRoot.setAttribute("data-a11y-patched", "true");

      const messages = chatRoot.querySelector(".n8n-chat-messages");
      if (messages) {
        messages.setAttribute("role", "log");
        messages.setAttribute("aria-live", "polite");
      }

      const input = chatRoot.querySelector(
        "input, textarea"
      ) as HTMLElement | null;

      if (input) {
        input.setAttribute("aria-label", "שדה כתיבת הודעה לצ׳אט");
      }
    }

    /* ---------------- ESC LISTENER (ONCE) ---------------- */

    if (!document.body.hasAttribute("data-chat-esc")) {
      document.body.setAttribute("data-chat-esc", "true");

      document.addEventListener(
        "keydown",
        (e) => {
          if (e.key === "Escape" && chatOpen) {
            const toggleBtn = document.querySelector(
              ".chat-window-toggle"
            ) as HTMLElement | null;

            toggleBtn?.click();
            chatOpen = false;
          }
        },
        true // capture phase (עוקף stopPropagation של n8n)
      );
    }

    if (toggle && chatRoot) {
      clearInterval(interval);
    }
  }, 200);
}
export function ChatWidget() {
  useEffect(() => {
    const webhookUrl = import.meta.env.VITE_N8N_CHAT_WEBHOOK;

    if (!webhookUrl) {
      console.warn(
        "n8n Chat Webhook URL not found. Please set VITE_N8N_CHAT_WEBHOOK in .env"
      );
      return;
    }

    createChat({
      webhookUrl: webhookUrl,
      mode: "window",
      chatInputKey: "chatInput",
      chatSessionKey: "sessionId",
      showWelcomeScreen: true,
      metadata: {},
      defaultLanguage: "en",
      initialMessages: [
        "שלום, כאן הצ’אט של משרד עו״ד ארז עזרא.\nניתן לקבל כאן מידע ראשוני.\nלמקרה אישי מומלץ ליצור קשר ישירות עם המשרד בטלפון 03-5563036.",
      ],
      i18n: {
        en: {
          title: "עו״ד ארז עזרא",
          subtitle: "צ׳אט בוט",
          footer: "",
          getStarted: "התחל שיחה",
          inputPlaceholder: "הקלד הודעה...",
          closeButtonTooltip: "סגור שיחה",
        },
      },
    });

    // Apply accessibility layer after mount
    enhanceAccessibility();
  }, []);

  return null;
}
